<template>
  <div class="container" style="min-height: 400px;">
    <div class="section-title">
      <h2><span>Your bookmarks ({{total}})</span></h2>
    </div>
    <div class="card">
      <div v-if="posts.listPost && posts.listPost.length > 0" id="listPost" class="card-body">
        <div v-for="(p, i) in posts.listPost" :key="p.id">
          <div v-if="i > 0" class="section-title"><h2>&nbsp;</h2></div>
          <h5 class="card-title"><a :href="'/post/'+linkPost(p.title, p.id)">{{p.title}}</a></h5>
          <div class="card-text">
            <small class="text-muted">Last edited {{p.updateTime}} ·<!--span class="dot"></span--> {{p.time}} min read ({{p.word}} words) </small>
            <a data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false"><font-awesome-icon icon="chevron-down"/></a>
            <div class="dropdown-menu dropdown-menu-right">
              <a class="dropdown-item" href @click.prevent="deleteBookmark(p.id)"><font-awesome-icon icon="times" /><span class="submenu">Remove</span></a>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="card-body">
        <p class="card-text">You have no bookmarks yet.</p>
        <!-- <p class="card-text">Bạn chưa có bài viết nào.</p> -->
      </div>
      
      <a v-if="isMore" href @click.prevent="loadMore">
        <div class="card-footer text-center"><font-awesome-icon icon="arrow-down" /> Load more</div>
      </a>
    </div>
  </div>
</template>

<script>
import UserService from "../services/user.service";
import PostService from "../services/post.service";
import LinkMixin from "../mixins/link";

export default {
  name: "Bookmark",
  mixins: [LinkMixin],
  data() {
    return {
      isMore: false,
      page: 1,
      total: 0,
      posts: {}
    };
  },
  computed: {
		currentUser() {
			return this.$store.state.auth.user;
    },
	},
	created () {
    // checkToken
		this.checkToken();
		// fetch the data when the view is created and the data is already being observed
		// https://router.vuejs.org/guide/advanced/data-fetching.html
    this.fetchData();
  },
  methods: {
    checkToken() {
			// console.log("In checkToken Bookmark");
			if(this.currentUser) {
				UserService.checkToken().then(data => {
					// console.log(data);
					if(data && data.err < 0) {
						this.$store.dispatch('auth/logout');
						window.location.reload();
					}
				});
			}
    },
    // linkPost(title, id) {
		// 	return title.toLowerCase().replace(/[:?&]/g,'-').split(' ').join('-') + "-" + id;
		// },
    fetchData () {
			this.getBookmark();
		},
		getBookmark() {
      // console.log('In getBookmark: ' + this.page);
			UserService.getBookmark(this.page).then(data => {
				// console.log(data);
				if(data && data.err >= 0) {
					// console.log('=============== Set List Data Posts Bookmark ===============');
          this.posts = data.posts;
          this.isMore = data.posts.isMore;
          this.total = data.posts.total;
				}
			});
    },
    reset() {
      this.isMore = false;
      this.page = 1;
      this.total = 0;
      this.posts = {};
    },
    loadMore() {
      this.page++;
      // console.log('In loadMore Bookmark: ' + this.page);
			UserService.getBookmark(this.page).then(data => {
				// console.log(data);
				if(data && data.err >= 0) {
					// console.log('=============== Set List Data loadMore Bookmark ===============');
          this.isMore = data.posts.isMore;
          this.posts.isMore = data.posts.isMore;
          this.posts.page = data.posts.page;
          // append array listpost.
          this.posts.listPost.push(...data.posts.listPost);
				}
			});
    },
    deleteBookmark(id) {
      // console.log('In deleteBookmark: ' + id);
      this.confirmDeleteBookmark(id);
    },
    confirmDeleteBookmark(id) {
      // console.log('In confirmDeleteBookmark: ' + id);
      this.$bvModal.msgBoxConfirm('Are you want to remove this post?', {
        title: 'Remove Confirm',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'YES',
        cancelTitle: 'NO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      }).then(value => {
        // console.log('confirmDeleteBookmark: ' + value);
        if(value) { // Confirm OK
          let formData = {
            "pid": id,
            "action": "unbookmarkPost"
          };
          PostService.bookmarkPost(formData).then(data => {
            // console.log(data);
            if(data && data.err >= 0) {
              // delete data in vue: this.posts.listPost
              this.posts.listPost = this.posts.listPost.filter(pt => pt.id !== id);
              this.total--;
            }
          });
        }
      }).catch(err => {
        // An error occurred
        console.log(err);
      })
    }
  }
}
</script>
